import type { MouseEvent } from 'react';
import type { FloraLibraryDocument } from '../../types/flora-ai.types';
import { FloraDocumentSkeleton } from '../FloraDocumentSkeleton/FloraDocumentSkeleton';
import styles from './FloraLibraryDocumentCard.module.css';

interface FloraLibraryDocumentCardProps {
	document: FloraLibraryDocument;
	isSelected: boolean;
	onToggleSelect: (documentId: string) => void;
	onToggleDossier: (documentId: string) => void;
}

const LIBRARY_IMAGE_SRC = '/flora-page/img_card_lib.png';

export const FloraLibraryDocumentCard = ({
	document,
	isSelected,
	onToggleSelect,
	onToggleDossier,
}: FloraLibraryDocumentCardProps) => {
	const { inDossier } = document;
	const isImage = document.kind === 'images';

	const cardClassName = [styles.card, inDossier ? styles.cardInDossier : '', isSelected ? styles.cardSelected : '']
		.filter(Boolean)
		.join(' ');
	const actionClassName = inDossier
		? `${styles.actionButton} ${styles.actionButtonActive}`
		: styles.actionButton;
	const thumbnailClassName = [
		styles.thumbnail,
		isImage ? styles.thumbnailImageMode : '',
		inDossier && !isImage ? styles.thumbnailWithBadge : '',
	]
		.filter(Boolean)
		.join(' ');

	const handleActionClick = (e: MouseEvent<HTMLButtonElement>) => {
		e.stopPropagation();
		onToggleDossier(document.id);
	};

	return (
		<div className={cardClassName} onClick={() => onToggleSelect(document.id)}>
			<div className={thumbnailClassName}>
				{inDossier && <span className={styles.badge}>No dossiê</span>}
				{isImage ? (
					<img src={LIBRARY_IMAGE_SRC} alt="" className={styles.thumbnailImage} />
				) : (
					<FloraDocumentSkeleton lineCount={inDossier ? 8 : 9} showTitle={!inDossier} />
				)}
			</div>

			<p className={styles.name}>{document.name}</p>
			<p className={styles.meta}>{document.meta}</p>

			<button type="button" className={actionClassName} onClick={handleActionClick}>
				{inDossier ? 'Tirar do dossiê' : 'Adicionar ao dossiê'}
			</button>
		</div>
	);
};
